import type { ReactNode } from 'react';

import { Label } from './Label.js';

export interface FormFieldProps {
  id: string;
  label: ReactNode;
  helperText?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  children: ReactNode;
}

export function FormField({
  id,
  label,
  helperText,
  error,
  required,
  children,
}: FormFieldProps): JSX.Element {
  const helperId = helperText ? `${id}-helper` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>
        {label}
        {required ? <span aria-hidden="true"> *</span> : null}
      </Label>
      {children}
      {helperText && !error && (
        <p id={helperId} className="text-xs text-fg-muted">
          {helperText}
        </p>
      )}
      {error && (
        <p id={errorId} className="text-xs text-danger" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
